import React, { useEffect, useState } from 'react';
import { getAllStudentRequests} from '../../services/studentRequestService';

import { Link } from "react-router-dom";
import "./datatable.scss"
import { DataGrid } from '@mui/x-data-grid';

export const StudentRequestList=()=> {
    const [studentRequests, setStudentRequests] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const fetchStudentRequests = async () => {
        try {
            const data = await getAllStudentRequests();
           // console.log(data);
            setStudentRequests(data.data);
        } catch (err) {
            setError(err);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {      

        fetchStudentRequests();
    }, []);


    const columns = React.useMemo(
        () => [
            { field: 'studentName', headerName: 'Student Name', width: 150 },
            { field: 'enrollmentNumber', headerName: 'Enrollment Number', width: 150 },
            { field: 'type', headerName: 'Type', width: 180 },
            { field: 'request', headerName: 'Request', width: 120 }
        ],
        []
    );

    if (loading) return <p>Loading...</p>;
    if (error) return <p>Error: {error.message}</p>;

    const actionColumn = [{ field: "action", headerName:"Action", width:200,
        renderCell:(params)=>{
            const { id } = params.row;
            return(
                <div className="cellAction">
                    <div className="viewButton"><Link to={{pathname: `/studentrequests/view-studentrequest/${id}`}} style={{textDecoration:"none"}}>View</Link></div>
                    <div className="editButton"><Link to={{pathname: `/studentrequests/edit-studentrequest/${id}`}} style={{textDecoration:"none" }}>Edit</Link></div>
                </div>
            );
        }
    }]

    return (
        <div className="datatable" >
        <div className="datatableTitle">


          <Link to="/studentrequests/new" className="link" >
          Add Student Request
          </Link>

        </div>
      
      <DataGrid 
      rows={studentRequests}
      columns={columns.concat(actionColumn)}
      initialState={{
        pagination: {
          paginationModel: { page: 0, pageSize: 10 },
        },
      }}
      pageSizeOptions={[5, 10]}
      //checkboxSelection
    />
  </div>
    );
}

